// frontend/shared-ui/src/forms/fields/NumberField.jsx
import React from "react";

export default function NumberField({ field, value, onChange, error }) {
  const inputId = `field-${field.key}`;
  return (
    <div className="fh-form-field">
      <label
        htmlFor={inputId}
        className={`fh-form-field__label ${field.required ? "is-required" : ""}`}
      >
        {field.label}
        {field.unit && (
          <span className="fh-form-field__unit"> ({field.unit})</span>
        )}
      </label>
      <input
        id={inputId}
        type="number"
        className={`fh-input ${error ? "is-invalid" : ""}`}
        value={value ?? ""}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === "" ? "" : Number(v));
        }}
        min={field.min}
        max={field.max}
        step={field.step ?? 1}
        placeholder={field.placeholder}
        disabled={field.disabled}
      />
      {field.hint && <div className="fh-form-field__hint">{field.hint}</div>}
      {error && <div className="fh-form-field__error">{error}</div>}
    </div>
  );
}
